import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ToastProvider } from "react-toast-notifications";
import { combineReducers, createStore } from "redux";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Apps from "./View/Apps";
// import 'antd/dist/antd.css';
import "antd/dist/antd.css";
import store from "./redux/store";
import authReducer from "./store/store";
import "./View/styleGlobal.css";

const reducers = combineReducers({
  auth: authReducer,
  // booking: bookingReducer
});

const reduxStore = createStore(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

ReactDOM.render(
  <Provider store={store}>
    <ToastProvider>
      <Apps />
    </ToastProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// serviceWorker.unregister();
